import {useDispatch, useSelector} from "react-redux";
import {appConfigSelector, rxSubmitSettingsPortfolio} from "../../../slices/appSlice";
import {useState} from "react";
import useToast from "../../../util/useToast";
import {useTranslation} from "react-i18next";
import {updateSettingsPortfolio} from "../../../api/ApiSettings";
import {selectAllAccounts} from "../../../slices/accountsSlice";
import {selectAllCategories} from "../../../slices/categoriesSlice";
import useNetwork from "../../../util/useNetwork";

const useSettingsPortfolio = () => {
  const dispatch = useDispatch();

  const {showToastSuccess} = useToast();
  const {handleNetworkError} = useNetwork();
  const {t} = useTranslation("settings_portfolio");

  const accounts = useSelector(selectAllAccounts);
  const transactionCategories = useSelector(selectAllCategories);
  const {
    featurePortfolioActive,
    defaultPortfolioAccount,
    defaultPortfolioTransactionCategory,
    portfolioCurrency
  } = useSelector(appConfigSelector);

  const [editedSettings, setEditedSettings] = useState({
    errors: {},
    featurePortfolioActive,
    defaultPortfolioAccount,
    defaultPortfolioTransactionCategory,
    portfolioCurrency
  });

  const availableCategories = transactionCategories.filter(c => c.active || c.id === defaultPortfolioTransactionCategory);

  const availableAccounts = [{id: null, name: t("settings_portfolio_editor_choose_account")}]

  accounts.filter(a => a.active || a.id === defaultPortfolioAccount).forEach(a => availableAccounts.push(a));

  const submit = e => {
    e.preventDefault();

    dispatch(rxSubmitSettingsPortfolio(editedSettings));

    updateSettingsPortfolio(editedSettings).catch(handleNetworkError);

    showToastSuccess(t("toast_portfolio_editor_saved"));
  };

  const updateSettings = field => event => {
    const values = {};

    switch (field) {
      case "featurePortfolioActive":
      case "defaultPortfolioAccount":
      case "defaultPortfolioTransactionCategory":
        values[field] = event;
        break;
      default:
        values[field] = event.target.value;
        break;
    }

    setEditedSettings(prev => ({...prev, ...values}));
  };

  return {
    t,
    editedSettings,
    submit,
    updateSettings,
    availableAccounts,
    availableCategories
  };
};

export default useSettingsPortfolio;
